/* PISTIS — 1:1 airless bottle. Spins only while the visitor drags. */
(function () {
  "use strict";

  var INCI =
    "Water, Lavandula Angustifolia (Lavender) Flower Water, Glycerin, Methyl Sulfonyl Methane, Equisetum Arvense Extract, Camellia Sinensis Leaf Extract, Laminaria Digitata Extract, Aloe Barbadensis Leaf Juice, Rosa Canina Seed Oil, Lavandula Angustifolia (Lavender) Oil, Mentha Piperita (Peppermint) Oil, Rosmarinus Officinalis (Rosemary) Leaf Oil, Panthenol, Sodium PCA, Sodium Lactate, Arginine, Aspartic Acid, PCA, Ethylhexylglycerin, Glycine, Alanine, Serine, Valine, Isoleucine, Proline, Threonine, Propanediol, Histidine, Phenylalanine, Citric Acid, Xanthan Gum, Sclerotium Gum, Potassium Sorbate, Sodium Benzoate.";

  function goldFill(ctx, x0, y0, x1, y1) {
    var g = ctx.createLinearGradient(x0, y0, x1, y1);
    g.addColorStop(0, "#8A7350");
    g.addColorStop(0.28, "#E4CFA0");
    g.addColorStop(0.5, "#C5A87A");
    g.addColorStop(0.72, "#F3E4BF");
    g.addColorStop(1, "#8A7350");
    return g;
  }

  function wrapText(ctx, text, x, y, maxWidth, lineHeight) {
    var words = text.split(" ");
    var line = "";
    var used = 0;
    for (var n = 0; n < words.length; n++) {
      var test = line ? line + " " + words[n] : words[n];
      if (ctx.measureText(test).width > maxWidth && line) {
        ctx.fillText(line, x, y + used);
        used += lineHeight;
        line = words[n];
      } else {
        line = test;
      }
    }
    if (line) {
      ctx.fillText(line, x, y + used);
      used += lineHeight;
    }
    return used;
  }

  function makeWrapTexture() {
    var w = 4096;
    var h = 2048;
    var c = document.createElement("canvas");
    c.width = w;
    c.height = h;
    var ctx = c.getContext("2d");
    if (!ctx) return null;
    ctx.clearRect(0, 0, w, h);

    /* Front brand — matches the physical bottle: gold foil on matte black. */
    var fx = Math.round(w * 0.25);
    ctx.save();
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    ctx.strokeStyle = goldFill(ctx, fx - 280, 0, fx + 280, 0);
    ctx.lineWidth = 3;
    ctx.beginPath();
    ctx.moveTo(fx - 220, 620);
    ctx.lineTo(fx + 220, 620);
    ctx.stroke();

    ctx.fillStyle = goldFill(ctx, fx - 360, 780, fx + 360, 900);
    ctx.font = "500 210px Georgia, 'Times New Roman', serif";
    ctx.letterSpacing = "0.22em";
    ctx.fillText("PISTIS", fx, 820);

    ctx.fillStyle = goldFill(ctx, fx - 300, 980, fx + 300, 1040);
    ctx.font = "500 42px Helvetica, Arial, sans-serif";
    ctx.letterSpacing = "0.46em";
    ctx.fillText("BOTANICAL HAIR SERUM", fx, 1010);

    ctx.font = "400 36px Helvetica, Arial, sans-serif";
    ctx.letterSpacing = "0.28em";
    ctx.fillText("30 mL  /  1 FL OZ", fx, 1100);

    ctx.strokeStyle = goldFill(ctx, fx - 280, 0, fx + 280, 0);
    ctx.lineWidth = 3;
    ctx.beginPath();
    ctx.moveTo(fx - 220, 1200);
    ctx.lineTo(fx + 220, 1200);
    ctx.stroke();
    ctx.restore();

    /* Back — professional cosmetic ingredient label (FDA-style). */
    var bx = Math.round(w * 0.75);
    var panelW = 1080;
    var panelH = 1560;
    var left = bx - panelW / 2;
    var top = 220;

    ctx.save();
    ctx.fillStyle = "rgba(14, 14, 14, 0.94)";
    ctx.strokeStyle = "#C5A87A";
    ctx.lineWidth = 4;
    roundRect(ctx, left, top, panelW, panelH, 10);
    ctx.fill();
    ctx.stroke();

    var pad = 56;
    var tx = left + pad;
    var maxW = panelW - pad * 2;
    var y = top + 70;

    ctx.textAlign = "center";
    ctx.textBaseline = "top";
    ctx.fillStyle = "#C5A87A";
    ctx.font = "500 54px Georgia, 'Times New Roman', serif";
    ctx.fillText("PISTIS", bx, y);
    y += 68;
    ctx.font = "500 22px Helvetica, Arial, sans-serif";
    ctx.letterSpacing = "0.28em";
    ctx.fillText("BOTANICAL HAIR SERUM", bx, y);
    y += 36;
    ctx.font = "400 20px Helvetica, Arial, sans-serif";
    ctx.letterSpacing = "0.12em";
    ctx.fillStyle = "#D4BC96";
    ctx.fillText("Net  30 mL e   ·   1 FL OZ", bx, y);
    y += 28;

    ctx.strokeStyle = "rgba(197, 168, 122, 0.55)";
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(tx, y + 12);
    ctx.lineTo(tx + maxW, y + 12);
    ctx.stroke();
    y += 36;

    ctx.textAlign = "left";
    ctx.fillStyle = "#C5A87A";
    ctx.font = "600 18px Helvetica, Arial, sans-serif";
    ctx.letterSpacing = "0.22em";
    ctx.fillText("INGREDIENTS", tx, y);
    y += 32;
    ctx.fillStyle = "#E8E2D6";
    ctx.font = "400 17px Helvetica, Arial, sans-serif";
    ctx.letterSpacing = "0px";
    y += wrapText(ctx, INCI, tx, y, maxW, 24) + 16;

    ctx.fillStyle = "#C5A87A";
    ctx.font = "600 18px Helvetica, Arial, sans-serif";
    ctx.letterSpacing = "0.22em";
    ctx.fillText("DIRECTIONS", tx, y);
    y += 30;
    ctx.fillStyle = "#E8E2D6";
    ctx.font = "400 17px Helvetica, Arial, sans-serif";
    ctx.letterSpacing = "0px";
    y +=
      wrapText(
        ctx,
        "Apply two to three pumps to clean, damp hair. Work from roots to ends. Style as usual. Use daily or as needed.",
        tx,
        y,
        maxW,
        24
      ) + 16;

    ctx.fillStyle = "#C5A87A";
    ctx.font = "600 18px Helvetica, Arial, sans-serif";
    ctx.letterSpacing = "0.22em";
    ctx.fillText("CAUTION", tx, y);
    y += 30;
    ctx.fillStyle = "#E8E2D6";
    ctx.font = "400 17px Helvetica, Arial, sans-serif";
    y +=
      wrapText(
        ctx,
        "For external use only. Avoid contact with eyes. Discontinue if irritation occurs. Patch-test before use if sensitive to lavender, peppermint, or rosemary. Keep out of reach of children. Cosmetic product — not intended to diagnose, treat, cure, or prevent any disease.",
        tx,
        y,
        maxW,
        24
      ) + 20;

    ctx.strokeStyle = "rgba(197, 168, 122, 0.55)";
    ctx.beginPath();
    ctx.moveTo(tx, y);
    ctx.lineTo(tx + maxW, y);
    ctx.stroke();
    y += 22;

    ctx.textAlign = "center";
    ctx.fillStyle = "#D4BC96";
    ctx.font = "500 16px Helvetica, Arial, sans-serif";
    ctx.fillText("Distributed by PISTIS", bx, y);
    y += 24;
    ctx.fillStyle = "#C5A87A";
    ctx.font = "400 16px Helvetica, Arial, sans-serif";
    ctx.fillText("support@pistisofficial.shop", bx, y);
    y += 24;
    ctx.fillStyle = "#A39E94";
    ctx.font = "400 15px Helvetica, Arial, sans-serif";
    ctx.fillText("Made in USA  ·  Cosmetic  ·  LOT 07", bx, y);
    ctx.restore();

    var tex = new THREE.CanvasTexture(c);
    tex.anisotropy = 8;
    if (THREE.sRGBEncoding) tex.encoding = THREE.sRGBEncoding;
    tex.needsUpdate = true;
    return tex;
  }

  function roundRect(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  function makeStudioEnv() {
    var c = document.createElement("canvas");
    c.width = 256;
    c.height = 128;
    var ctx = c.getContext("2d");
    if (!ctx) return null;
    var sky = ctx.createLinearGradient(0, 0, 0, 128);
    sky.addColorStop(0, "#2c2a27");
    sky.addColorStop(0.4, "#141312");
    sky.addColorStop(1, "#070707");
    ctx.fillStyle = sky;
    ctx.fillRect(0, 0, 256, 128);
    ctx.fillStyle = "rgba(197,168,122,0.22)";
    ctx.fillRect(148, 10, 42, 18);
    ctx.fillStyle = "rgba(255,244,228,0.08)";
    ctx.fillRect(24, 72, 56, 16);
    var tex = new THREE.CanvasTexture(c);
    tex.mapping = THREE.EquirectangularReflectionMapping;
    if (THREE.sRGBEncoding) tex.encoding = THREE.sRGBEncoding;
    tex.needsUpdate = true;
    return tex;
  }

  function buildBottle() {
    var group = new THREE.Group();

    var matte = new THREE.MeshPhysicalMaterial({
      color: 0x050505,
      roughness: 0.94,
      metalness: 0.0,
      clearcoat: 0.04,
      clearcoatRoughness: 0.9,
      envMapIntensity: 0.16,
    });
    var gloss = new THREE.MeshPhysicalMaterial({
      color: 0x070707,
      roughness: 0.82,
      metalness: 0.02,
      clearcoat: 0.14,
      clearcoatRoughness: 0.62,
      envMapIntensity: 0.2,
    });
    var gold = new THREE.MeshPhysicalMaterial({
      color: 0xc5a87a,
      roughness: 0.24,
      metalness: 0.92,
      envMapIntensity: 0.55,
    });
    var label = new THREE.MeshPhysicalMaterial({
      color: 0xffffff,
      roughness: 0.42,
      metalness: 0.12,
      map: makeWrapTexture(),
      transparent: true,
      alphaTest: 0.08,
      depthWrite: true,
      envMapIntensity: 0.28,
    });

    /* Body — tall matte cylinder matching the 30 ml airless vessel. */
    var body = new THREE.Mesh(new THREE.CylinderGeometry(0.4, 0.4, 2.18, 96), matte);
    body.position.y = -0.22;
    body.castShadow = true;
    group.add(body);

    var wrap = new THREE.Mesh(new THREE.CylinderGeometry(0.403, 0.403, 1.72, 96, 1, true), label);
    wrap.position.y = -0.18;
    wrap.renderOrder = 2;
    group.add(wrap);

    var base = new THREE.Mesh(new THREE.CylinderGeometry(0.4, 0.372, 0.07, 96), matte);
    base.position.y = -1.345;
    group.add(base);

    var foot = new THREE.Mesh(new THREE.CylinderGeometry(0.36, 0.36, 0.03, 64), matte);
    foot.position.y = -1.385;
    group.add(foot);

    /* Gold collar at the cap / body join. */
    var ring = new THREE.Mesh(new THREE.CylinderGeometry(0.408, 0.408, 0.022, 96), gold);
    ring.position.y = 0.9;
    group.add(ring);

    var shoulder = new THREE.Mesh(new THREE.CylinderGeometry(0.392, 0.4, 0.05, 64), matte);
    shoulder.position.y = 0.86;
    group.add(shoulder);

    /* Glossy pump cap. */
    var cap = new THREE.Mesh(new THREE.CylinderGeometry(0.392, 0.392, 0.78, 96), gloss);
    cap.position.y = 1.31;
    cap.castShadow = true;
    group.add(cap);

    var capTop = new THREE.Mesh(new THREE.CylinderGeometry(0.3, 0.392, 0.07, 64), gloss);
    capTop.position.y = 1.735;
    group.add(capTop);

    var collar = new THREE.Mesh(new THREE.CylinderGeometry(0.22, 0.22, 0.06, 48), gloss);
    collar.position.y = 1.78;
    group.add(collar);

    var actuator = new THREE.Mesh(new THREE.CylinderGeometry(0.1, 0.13, 0.1, 32), matte);
    actuator.position.y = 1.85;
    group.add(actuator);

    var nozzle = new THREE.Mesh(new THREE.CylinderGeometry(0.045, 0.05, 0.05, 16), matte);
    nozzle.position.set(0.09, 1.86, 0);
    nozzle.rotation.z = Math.PI / 2.6;
    group.add(nozzle);

    return group;
  }

  function mount(stage) {
    if (!window.THREE) return false;
    if (stage.getAttribute("data-bottle-mounted") === "1") return true;
    var host = stage.querySelector("[data-bottle-canvas]");
    if (!host) return false;
    var fallback = stage.querySelector("[data-bottle-fallback]");
    var w = host.clientWidth || stage.clientWidth || 480;
    var h = host.clientHeight || stage.clientHeight || 640;
    if (w < 8 || h < 8) return false;

    var renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, powerPreference: "high-performance" });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 1.8));
    renderer.setSize(w, h);
    if (THREE.sRGBEncoding) renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.shadowMap.enabled = true;
    host.appendChild(renderer.domElement);
    renderer.domElement.style.display = "block";
    renderer.domElement.style.width = "100%";
    renderer.domElement.style.height = "100%";
    renderer.domElement.style.cursor = "grab";
    renderer.domElement.style.touchAction = "none";
    renderer.domElement.setAttribute("aria-label", "PISTIS bottle. Spin to move. Scroll or pinch to zoom.");
    renderer.domElement.setAttribute("role", "img");

    var scene = new THREE.Scene();
    var env = makeStudioEnv();
    if (env) scene.environment = env;

    var DEFAULT_Z = 7.65;
    var MIN_Z = 5.1;
    var MAX_Z = 10.3;
    var camZ = DEFAULT_Z;

    var camera = new THREE.PerspectiveCamera(28, w / h, 0.1, 40);
    camera.position.set(0, 0.1, camZ);
    camera.lookAt(0, 0.02, 0);

    scene.add(new THREE.AmbientLight(0xf2eee8, 0.18));
    var key = new THREE.DirectionalLight(0xfff1de, 0.95);
    key.position.set(2.2, 3.4, 3.8);
    key.castShadow = true;
    scene.add(key);
    var fill = new THREE.DirectionalLight(0x5c5854, 0.22);
    fill.position.set(-3.2, 1.0, -1.2);
    scene.add(fill);
    var rim = new THREE.SpotLight(0xc5a87a, 0.32, 14, 0.42, 0.85);
    rim.position.set(0, 5.2, 2.2);
    scene.add(rim);
    var bounce = new THREE.DirectionalLight(0x1a1a1a, 0.12);
    bounce.position.set(0, -3, 2);
    scene.add(bounce);

    var bottle = buildBottle();
    bottle.position.set(0, -0.22, 0);
    /* Slight 3/4 start, front label facing the camera. */
    bottle.rotation.set(0.04, 0.18, 0);
    scene.add(bottle);

    var shadowGeo = new THREE.CircleGeometry(1.2, 48);
    var shadowMat = new THREE.MeshBasicMaterial({ color: 0x000000, transparent: true, opacity: 0.4 });
    var shadow = new THREE.Mesh(shadowGeo, shadowMat);
    shadow.rotation.x = -Math.PI / 2;
    shadow.position.y = -1.48;
    scene.add(shadow);

    if (fallback) fallback.style.opacity = "0";
    host.style.opacity = "1";
    stage.setAttribute("data-bottle-mounted", "1");

    var dragging = false;
    var lastX = 0;
    var vel = 0;
    var rotY = bottle.rotation.y;
    var pointerId = null;
    var pointers = {};
    var pinchStart = 0;
    var pinchZ = camZ;

    function clampZ(z) {
      return Math.max(MIN_Z, Math.min(MAX_Z, z));
    }

    function applyZoom(z) {
      camZ = clampZ(z);
      camera.position.z = camZ;
    }

    function clientX(e) {
      if (e.clientX != null) return e.clientX;
      if (e.touches && e.touches[0]) return e.touches[0].clientX;
      if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].clientX;
      return 0;
    }

    function pointerCount() {
      return Object.keys(pointers).length;
    }

    function pinchDistance() {
      var ids = Object.keys(pointers);
      if (ids.length < 2) return 0;
      var a = pointers[ids[0]];
      var b = pointers[ids[1]];
      var dx = a.x - b.x;
      var dy = a.y - b.y;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function onDown(e) {
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (pointerCount() >= 2) {
        dragging = false;
        pinchStart = pinchDistance();
        pinchZ = camZ;
        renderer.domElement.style.cursor = "grab";
        e.preventDefault();
        return;
      }
      dragging = true;
      pointerId = e.pointerId;
      lastX = clientX(e);
      vel = 0;
      renderer.domElement.style.cursor = "grabbing";
      try {
        renderer.domElement.setPointerCapture(e.pointerId);
      } catch {}
      e.preventDefault();
    }
    function onMove(e) {
      if (pointers[e.pointerId]) {
        pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      }
      if (pointerCount() >= 2 && pinchStart > 0) {
        var dist = pinchDistance();
        if (dist > 0) {
          applyZoom(pinchZ * (pinchStart / dist));
        }
        e.preventDefault();
        return;
      }
      if (!dragging) return;
      if (pointerId != null && e.pointerId != null && e.pointerId !== pointerId) return;
      var x = clientX(e);
      var dx = x - lastX;
      vel = dx * 0.0075;
      rotY += vel;
      lastX = x;
    }
    function onUp(e) {
      delete pointers[e.pointerId];
      if (pointerCount() < 2) {
        pinchStart = 0;
      }
      if (pointerId != null && e && e.pointerId != null && e.pointerId !== pointerId) return;
      dragging = false;
      pointerId = null;
      renderer.domElement.style.cursor = "grab";
    }

    function onWheel(e) {
      e.preventDefault();
      applyZoom(camZ + e.deltaY * 0.0065);
    }

    renderer.domElement.addEventListener("pointerdown", onDown);
    renderer.domElement.addEventListener("pointermove", onMove);
    renderer.domElement.addEventListener("pointerup", onUp);
    renderer.domElement.addEventListener("pointercancel", onUp);
    renderer.domElement.addEventListener("lostpointercapture", onUp);
    renderer.domElement.addEventListener("wheel", onWheel, { passive: false });

    function resize() {
      var nw = host.clientWidth || stage.clientWidth;
      var nh = host.clientHeight || stage.clientHeight;
      if (!nw || !nh) return;
      camera.aspect = nw / nh;
      camera.updateProjectionMatrix();
      renderer.setSize(nw, nh);
    }
    window.addEventListener("resize", resize);

    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var alive = true;
    function tick() {
      if (!alive) return;
      if (!dragging) {
        if (!reduce && Math.abs(vel) > 0.00025) {
          rotY += vel;
          vel *= 0.9;
        } else {
          vel = 0;
        }
      }
      bottle.rotation.y = rotY;
      renderer.render(scene, camera);
      requestAnimationFrame(tick);
    }
    tick();
    return true;
  }

  function start() {
    var stages = document.querySelectorAll("[data-bottle-3d]");
    if (!stages.length) return;
    if (!window.THREE || !window.WebGLRenderingContext) {
      stages.forEach(function (s) {
        var f = s.querySelector("[data-bottle-fallback]");
        if (f) f.style.opacity = "1";
      });
      return;
    }
    stages.forEach(function (stage) {
      try {
        if (!mount(stage)) {
          var f = stage.querySelector("[data-bottle-fallback]");
          if (f) f.style.opacity = "1";
        }
      } catch {
        var fb = stage.querySelector("[data-bottle-fallback]");
        if (fb) fb.style.opacity = "1";
      }
    });
  }

  window.PistisBottle = { mountAll: start, mount: mount };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
